import { createAction } from 'redux-actions'

export const onRotatePageRequest = createAction('ON_ROTATE_PAGE_REQUEST')
export const onRotatePageSuccess = createAction('ON_ROTATE_PAGE_SUCCESS')
export const onRotatePageFailed = createAction('ON_ROTATE_PAGE_FAILED')
